import React from 'react'
import Helmet from 'react-helmet'
import { useIntl } from 'react-intl'
import ArchivesPanel from 'components/ArchivesPanel/ArchivesPanel'
import Layout from 'components/Layout/Layout'

const Archives = () => {
  const title = useIntl().formatMessage({ id: 'Archives.title' }, { 0: process.env.REACT_APP_PAGE_TITLE })

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Layout>
        <ArchivesPanel />
      </Layout>
    </>
  )
}

export default Archives
